import { useQuery } from "@tanstack/react-query";
import { getOpportunitiesSummary } from "@/helpers/apis";
import { GET_SUMMARY_DATA } from "../constants";
import { useExplorerFiltersFromUrl } from "./useExplorerFiltersFromUrl";

interface UseSummaryQueryOptions {
  enabled?: boolean;
}

export const useSummaryQuery = (options: UseSummaryQueryOptions = {}) => {
  const { enabled = true } = options;
  const { filterParams } = useExplorerFiltersFromUrl();

  return useQuery({
    queryKey: [GET_SUMMARY_DATA, filterParams],
    queryFn: () => getOpportunitiesSummary(filterParams),
    enabled,
  });
};
